import { getComponentData } from '@backstage/core-plugin-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  createFormField,
  FormFieldBlueprint,
  FormFieldExtensionData,
} from '@backstage/plugin-scaffolder-react/alpha';
import { SelectFieldFromApiExtension } from '@roadiehq/plugin-scaffolder-frontend-module-http-request-field';
import { AsyncDomainSelectFormField } from '../components/scaffolder/AsyncDomainSelect';
import { AsyncProductAndServiceSelectFormField } from '../components/scaffolder/AsyncProductAndServiceSelect';
import { AsyncProductAndSubdomainSelectFormField } from '../components/scaffolder/AsyncProductAndSubdomainSelect';
import { AsyncProductSelectFormField } from '../components/scaffolder/AsyncProductSelect';
import { AsyncServiceSelectFormField } from '../components/scaffolder/AsyncServiceSelect';
import { AsyncSubdomainSelectFormField } from '../components/scaffolder/AsyncSubdomainSelect';
import { AsyncTeamSelectFormField } from '../components/scaffolder/AsyncTeamSelect';
import { EntityPickerWithDefaultsFormField } from '../components/scaffolder/EntityPickerWithDefaults';
import { UniqueServiceNameInputFormField } from '../components/scaffolder/UniqueServiceNameInput';

// Key under which `createScaffolderFieldExtension` (scaffolder-react
// `dist/extensions/keys.esm.js`) attaches a legacy field's options.
const LEGACY_FIELD_EXTENSION_KEY = 'scaffolder.extensions.field.v1';

/**
 * The Roadie http-request-field module only ships a legacy field extension.
 * Its options (name, component, schema) are read from that extension so the
 * field is registered unchanged in the new scaffolder.
 */
const selectFieldFromApiFormField = FormFieldBlueprint.make({
  name: 'select-field-from-api',
  params: {
    field: async () => {
      const options = getComponentData<FormFieldExtensionData>(
        <SelectFieldFromApiExtension />,
        LEGACY_FIELD_EXTENSION_KEY,
      );
      if (!options) {
        throw new Error(
          'SelectFieldFromApiExtension carries no scaffolder field data',
        );
      }
      return createFormField(options);
    },
  },
});

/** The portal's custom scaffolder form fields. */
export const scaffolderFormFields = [
  AsyncDomainSelectFormField,
  AsyncProductAndServiceSelectFormField,
  AsyncProductAndSubdomainSelectFormField,
  AsyncProductSelectFormField,
  AsyncServiceSelectFormField,
  AsyncSubdomainSelectFormField,
  AsyncTeamSelectFormField,
  EntityPickerWithDefaultsFormField,
  selectFieldFromApiFormField,
  UniqueServiceNameInputFormField,
];

export const scaffolderFieldsModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: scaffolderFormFields,
});
